import { createFileRoute } from '@tanstack/react-router'
import { FinanceSection } from '~/components/marketing/finance-section'
import { MarketingShell } from '~/components/marketing/marketing-shell'
import { PricingEngineSection } from '~/components/marketing/pricing-engine-section'
import { marketingPageHead } from '~/lib/site-meta'

const PAGE_TITLE = 'Finances — billable rate and cash flow | Planno'
const PAGE_DESCRIPTION =
  'A billable rate calculated from your practice’s real costs, payment schedules that unfold on their own, and a P&L that shows where the margin went.'

export const Route = createFileRoute('/en/features/finances')({
  component: FinancesPage,
  head: () =>
    marketingPageHead({
      description: PAGE_DESCRIPTION,
      locale: 'en',
      path: '/en/features/finances',
      title: PAGE_TITLE,
    }),
})

function FinancesPage() {
  return (
    <MarketingShell locale="en">
      <PricingEngineSection headingLevel="h1" />
      <FinanceSection />
    </MarketingShell>
  )
}
